// Twelve of the fifteen-odd digits a double carries: enough that a conversion is exact wherever it can be, and few
// enough that the noise the last three hold — the 0.30000000000000004 of adding 0.1 to 0.2 — never reaches the page.
const SIGNIFICANT_DIGITS = 12;

// Whatever `Number` itself reads, which is a decimal, an exponent or a 0x literal, and never a unit written after it:
// a box that quietly took "5 m" as five would be one nobody could tell had ignored half of what they typed.
export function parseAmount(text: string): number | null {
  const trimmed = text.trim();
  if (!trimmed) return null;
  const value = Number(trimmed);
  return Number.isFinite(value) ? value : null;
}

export function formatAmount(value: number): string {
  // A conversion that ran off the end of a double is not a number to write down.
  if (!Number.isFinite(value)) return "";
  // Rounded first and spelled after: toPrecision writes 1.00000000000e+15 for anything with more digits than places,
  // where String leaves a whole number whole and reaches for an exponent only past 1e21 and below 1e-6.
  return String(Number(value.toPrecision(SIGNIFICANT_DIGITS)));
}
